/* eslint-disable @next/next/no-img-element */
import Link from 'next/link';
import { parseISO, format } from 'date-fns';

import Skeleton from './ProfileSkeleton';
import { extractUserData } from './utils';
import {
  ProfileWrapper,
  ImageContainer,
  ProfileInfoContainer,
  TopHeader,
  MidleHeader,
  BottomHeader,
} from './guest.styled';
import { ProfileGraphInfo } from './types';

interface ProfileProps {
  user: ProfileGraphInfo;
}

export default function Profile({ user }: ProfileProps) {
  const {
    username,
    fullname,
    avatarUrl,
    ideaCount,
    followerCount,
    userData,
  } = extractUserData(user);

  if (!username) {
    return <Skeleton />;
  }

  return (
    <ProfileWrapper>
      <ImageContainer>
        <img
          src={avatarUrl}
          alt={username}
          width={150}
          height={150}
          style={{ borderRadius: '50%' }}
        />
      </ImageContainer>

      <ProfileInfoContainer>
        <TopHeader>
          <h1>{fullname}</h1>
          <p>@{username}</p>

          <Link href="/login">
            <a>
              <button type="button">Follow</button>
            </a>
          </Link>
        </TopHeader>

        <MidleHeader>
          <p>Joined: {format(parseISO(userData?.created_at), 'dd MMM yyyy')}</p>
        </MidleHeader>

        <BottomHeader>
          <p>
            {ideaCount} <span>Posts</span>
          </p>
          <span>{' · '}</span>
          <p>
            {followerCount} <span>Followers</span>
          </p>
        </BottomHeader>
      </ProfileInfoContainer>
    </ProfileWrapper>
  );
}
